import { Injectable } from "@angular/core";
import { JwtHelperService } from "@auth0/angular-jwt";
import { Constants } from "../constants/constants";

@Injectable({
    providedIn: 'root'
})
export class AuthenticationService {

    constructor() {}

    public setAccessToken(accessToken: string) {
        localStorage.setItem(Constants.LocalStorageKey.TOKEN_KEY, accessToken);
    }

    public getAccessToken(): any {
        return localStorage.getItem(Constants.LocalStorageKey.TOKEN_KEY);
    }

    public deleteAccessToken() {
        localStorage.removeItem(Constants.LocalStorageKey.TOKEN_KEY);
    }

    public setUserRoles(roles: any) {
        localStorage.setItem(Constants.LocalStorageKey.USER_ROLES, JSON.stringify(roles));
    }

    public getUserRoles(): any {
        return localStorage.getItem(Constants.LocalStorageKey.USER_ROLES);
    }

    public isAuthenticated(): boolean {
        const token = this.getAccessToken();
        if (!token || token === '') {
            return false;
        }
        return !this.isTokenExpired(token);
    }

    public getDecodeAccessToken() {
        const helper = new JwtHelperService();
        return helper.decodeToken(this.getAccessToken());
    }

    public decodeAccessToken(token: string) {
        const helper = new JwtHelperService();
        return helper.decodeToken(token);
    }

    public setCurrentUserInfo(userInfo: any) {
        localStorage.setItem(Constants.LocalStorageKey.USER, JSON.stringify(userInfo));
    }

    public getCurrentUserInfo(): any {
        const userInfo = localStorage.getItem(Constants.LocalStorageKey.USER);
        if (userInfo) {
            return JSON.parse(userInfo);
        } else {
            return null;
        }
    }

    public deleteCurrentUserInfo() {
        localStorage.removeItem(Constants.LocalStorageKey.USER);
    }

    public logout() {
        this.deleteAccessToken();
        this.deleteCurrentUserInfo();
        
        const keysToKeep = ['lang', 'langVersion'];
        const savedValues = keysToKeep.reduce((acc, key) => {
            const value = localStorage.getItem(key);
            if (value !== null) acc[key] = value;
            return acc;
        }, {} as Record<string, string>);
        
        localStorage.clear();
        
        Object.entries(savedValues).forEach(([key, value]) => {
            localStorage.setItem(key, value);
        });
    }

    public getCurrentUserId() {
        var currentUser = this.getCurrentUserInfo();
        if (currentUser?.jti) {
            return currentUser.jti;
        }
        return "";
    }

    public getCurrentUsername() {
        var currentUser = this.getCurrentUserInfo();
        if (currentUser?.sub) {
            return currentUser.sub;
        }
        return "";
    }

    public getCurrentCashDeskId() {
        var currentUser = this.getCurrentUserInfo();
        if (currentUser?.cashDeskId) {
            return currentUser.cashDeskId;
        }
        return "";
    }

    public getCurrentBranchId() {
        var currentUser = this.getCurrentUserInfo();
        if (currentUser?.branchId) {
            return currentUser.branchId;
        }
        return "";
    }

    public isTokenExpired(token: string): boolean {
        if (typeof token !== 'string' || token.trim() === '') {
            return true;
        }
        const helper = new JwtHelperService();
        try {
            return helper.isTokenExpired(token) as boolean;
        } catch (e) {
            return true;
        }
    }

}
